import { DOWNLOADABLE_FILE_TYPES, VIEWABLE_FILE_TYPES } from './constants';

export async function getContentTypeFromFetchResponse(url: string, signal?: AbortSignal) {
  let validatedUrl: string;
  try {
    validatedUrl = new URL(url).toString();
  } catch (err) {
    if (err instanceof Error) {
      throw new Error(`Invalid URL provided: ${url}. ${err.message}`);
    }
    throw new Error(`Invalid URL provided: ${url}`);
  }

  try {
    const response = await fetch(validatedUrl, {
      method: 'HEAD',
      signal,
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch URL: ${validatedUrl}, status: ${response.status}`);
    }

    return response.headers.get('Content-Type');
  } catch (err) {
    let errorMessage = '';
    if (err instanceof Error) {
      errorMessage = err.message;
    } else {
      errorMessage = String(err);
    }
    throw new Error(`Network error while fetching URL: ${validatedUrl}. ${errorMessage}`);
  }
}

export function getModeByFileType(fileType: string) {
  if (VIEWABLE_FILE_TYPES.includes(fileType)) {
    return 'preview';
  }
  if (DOWNLOADABLE_FILE_TYPES.includes(fileType)) {
    return 'download';
  }

  throw new Error(`Unsupported file type: ${fileType}`);
}
